module.exports = __webpack_public_path__ + "static/intro_mission_girl-69c1f9bd208227de931e4417be899f80.svg";